// extracted by mini-css-extract-plugin
export var accordionButton = "l_4";
export var accordionContainer = "l_3";
export var accordionContent = "l_7";
export var accordionItem = "l_6";
export var open = "l_T";
export var thickerTop = "l_5";